import Head from "next/head";
import { useRouter } from "next/router";

import { withLocale } from "@/common/utils/url.utils";
import { CANONICAL_HOST } from "@/config";

export const FeedHead = () => {
  const { locale, defaultLocale } = useRouter();
  const feedUrl = `${CANONICAL_HOST}${withLocale(
    "/rss",
    locale,
    defaultLocale
  )}`;
  return (
    <Head>
      <link rel="alternate" type="application/rss+xml" href={feedUrl} />
    </Head>
  );
};
